<div class="container py-4">
  <div style="display: inline-flex;justify-content: center; max-width:100%">
    <div class="col-12 col-xl-10">

      <mat-stepper [orientation]="(stepperOrientation | async)!" #stepper linear>
        <!-- STEP 1: Applicant Info -->
        <mat-step [stepControl]="stepApplicant">
          <ng-template matStepLabel>
            <div class="steps-header" >
              <mat-icon>person</mat-icon> Applicant Information
            </div>
        </ng-template>

          <form [formGroup]="stepApplicant">

            <div class="row g-3">

              <div class="col-12 col-md-6">
                <label data-required="*">Full Name</label>
                <input formControlName="fullName" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicant,'fullName')">Required</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">Date of Birth</label>
                <input type="date" formControlName="dob" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicant,'dob')">Required</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">SSN</label>
                <input formControlName="ssn" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicant,'ssn')">Required</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">Phone</label>
                <input formControlName="phone" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicant,'phone')">Required</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">Email</label>
                <input type="email" formControlName="applicantEmail" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicant,'applicantEmail')">Required / Invalid</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">Driver’s License #</label>
                <input formControlName="driversLicenseNum" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicant,'driversLicenseNum')">Required</small>
              </div>

              <!-- Additional Occupants -->
              <div class="col-12">
                <label data-required="*">Additional Occupants? (Dependents or anyone other than the CoApplicant)</label>
                <select formControlName="additionalOccupants" class="form-select">
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                <div *ngIf="stepApplicant.get('additionalOccupants')?.value === 'Yes'" class="mt-2">
                  <label>Description</label>
                  <input formControlName="occupantsDescription" class="form-control" />
                </div>
              </div>

              <!-- Pets -->
              <div class="col-12">
                <label data-required="*">Do you have pets?</label>
                <select formControlName="hasPets" class="form-select">
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                <div *ngIf="stepApplicant.get('hasPets')?.value === 'Yes'" class="mt-2">
                  <label>Pets Description</label>
                  <input formControlName="petsDescription" class="form-control" />
                </div>
              </div>

            </div>

            <div class="mt-4 text-end">
              <button mat-button matStepperNext [disabled]="stepApplicant.invalid">Next</button>
            </div>
          </form>
        </mat-step>

        <!-- STEP 1b: Applicant Employment -->
        <mat-step [stepControl]="stepApplicantEmployment">
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>work</mat-icon>Applicant Job</div></ng-template>

          <form [formGroup]="stepApplicantEmployment">

            <div class="row g-3">

              <div class="col-12">
                <label data-required="*">Employer Name</label>
                <input formControlName="employerName" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicantEmployment,'employerName')">Required</small>
              </div>

              <div class="col-12">
                <label>Employer Address</label>
                <input formControlName="employerAddress" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">Job Title</label>
                <input formControlName="jobTitle" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicantEmployment,'jobTitle')">Required</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">Monthly Income</label>
                <input type="number" formControlName="income" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepApplicantEmployment,'income')">Required</small>
              </div>

              <div class="col-12">
                <label>How Long Employed</label>
                <input formControlName="jobHowLong" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Supervisor Name</label>
                <input formControlName="supervisorName" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Supervisor Phone</label>
                <input formControlName="supervisorPhone" class="form-control" />
              </div>

              <div class="col-12">
                <label>Supervisor Email</label>
                <input formControlName="supervisorEmail" class="form-control" />
              </div>

            </div>

            <div class="mt-4 d-flex justify-content-between">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext [disabled]="stepApplicantEmployment.invalid">Next</button>
            </div>

          </form>
        </mat-step>

        <!-- STEP 2: Add co-applicant -->
        <mat-step>
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>group_add</mat-icon>Do you have a Co-Applicant?</div></ng-template>

          <p>Do you want to add a co-applicant?</p>

          <div class="d-flex gap-3 mt-3">
            <button mat-raised-button color="primary" (click)="stepper.selectedIndex = 3">Yes</button>
            <button mat-stroked-button color="accent" (click)="stepper.selectedIndex = 5">No</button>
          </div>
        </mat-step>

        <!-- STEP 3: Co-Applicant Info -->
        <mat-step [stepControl]="stepCoApplicant" optional>
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>group</mat-icon>Co-Applicant Info</div></ng-template>

          <form [formGroup]="stepCoApplicant">

            <div class="row g-3">

              <div class="col-12 col-md-6">
                <label>Full Name</label>
                <input formControlName="coAppFullName" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>SSN</label>
                <input formControlName="coAppSSN" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>DOB</label>
                <input type="date" formControlName="coAppDOB" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Phone</label>
                <input formControlName="coAppPhone" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Email</label>
                <input type="email" formControlName="coAppEmail" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>License #</label>
                <input formControlName="coAppLicenseNum" class="form-control" />
              </div>

              <div class="col-12">
                <label>Co-Applicant Current Address</label>
                <input formControlName="coAddress" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Co-Applicant Monthly Rent</label>
                <input formControlName="coRent" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>How Long</label>
                <input formControlName="cohowLong" class="form-control" />
              </div>

            </div>

            <div class="mt-4 d-flex justify-content-between">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>

          </form>
        </mat-step>

        <!-- STEP 4: Co-Applicant Employment -->
        <mat-step  [stepControl]="stepCoEmployment"  optional>
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>work_outline</mat-icon>Co-Applicant Job</div></ng-template>

          <form [formGroup]="stepCoEmployment">

            <div class="row g-3">

              <div class="col-12">
                <label>Employer Name</label>
                <input formControlName="coemployerName" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Job Title</label>
                <input formControlName="cojobTitle" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Monthly Income</label>
                <input type="number" formControlName="coincome" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Supervisor</label>
                <input formControlName="cosupervisorName" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Supervisor Phone</label>
                <input formControlName="cosupervisorPhone" class="form-control" />
              </div>

              <div class="col-12">
                <label>Supervisor Email</label>
                <input formControlName="cosupervisorEmail" class="form-control" />
              </div>

            </div>

            <div class="mt-4 d-flex justify-content-between">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>

          </form>
        </mat-step>

        <!-- STEP X: Residence -->
        <mat-step [stepControl]="stepResidence">
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>home</mat-icon>Applicant Residence</div></ng-template>

          <form [formGroup]="stepResidence">

            <div class="row g-3">

              <div class="col-12">
                <label data-required="*">Current Address</label>
                <input formControlName="currentAddress" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepResidence,'currentAddress')">Required</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">Monthly Rent</label>
                <input type="number" formControlName="currentRent" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepResidence,'currentRent')">Required</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">How Long</label>
                <input formControlName="howLong" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepResidence,'howLong')">Required</small>
              </div>

              <div class="col-12">
                <label>Reason for Moving</label>
                <input formControlName="currentReason" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Landlord Name</label>
                <input formControlName="currentLandlordName" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Landlord Email</label>
                <input type="email" formControlName="currentLandlordEmail" class="form-control" />
              </div>

              <div class="col-12">
                <label>Landlord Phone</label>
                <input formControlName="currentLandlordPhone" class="form-control" />
              </div>

            </div>

            <div class="mt-4 d-flex justify-content-between">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext [disabled]="stepResidence.invalid">Next</button>
            </div>

          </form>
        </mat-step>

        <!-- STEP: Vehicles -->
        <mat-step [stepControl]="stepVehicles">
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>directions_car</mat-icon>Applicant Vehicles</div></ng-template>

          <form [formGroup]="stepVehicles">

            <div class="row g-3">

              <div class="col-12"><h4>Vehicle 1</h4></div>

              <div class="col-12 col-md-6">
                <label>Make</label>
                <input formControlName="vehicle1Make" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Model</label>
                <input formControlName="vehicle1Model" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Year</label>
                <input formControlName="vehicle1Year" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Color</label>
                <input formControlName="vehicle1Color" class="form-control" />
              </div>

              <div class="col-12">
                <label>Plate</label>
                <input formControlName="vehicle1Plate" class="form-control" />
              </div>

              <!-- Vehicle 2 -->
              <div class="col-12 mt-4"><h4>Vehicle 2 (optional)</h4></div>

              <div class="col-12 col-md-6">
                <label>Make</label>
                <input formControlName="vehicle2Make" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Model</label>
                <input formControlName="vehicle2Model" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Year</label>
                <input formControlName="vehicle2Year" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Color</label>
                <input formControlName="vehicle2Color" class="form-control" />
              </div>

              <div class="col-12">
                <label>Plate</label>
                <input formControlName="vehicle2Plate" class="form-control" />
              </div>

            </div>

            <div class="mt-4 d-flex justify-content-between">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>

          </form>
        </mat-step>


        <!-- STEP: References -->
        <mat-step [stepControl]="stepReferences">
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>people</mat-icon>Applicant References</div></ng-template>

          <form [formGroup]="stepReferences">

            <div class="row g-3">

              <div class="col-12 col-md-6">
                <label>Reference 1 Name</label>
                <input formControlName="ref1name" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Reference 1 Phone</label>
                <input formControlName="ref1Phone" class="form-control" />
              </div>

              <div class="col-12">
                <label>Relationship</label>
                <input formControlName="ref1Relationship" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Reference 2 Name</label>
                <input formControlName="ref2name" class="form-control" />
              </div>
              <div class="col-12 col-md-6">
                <label>Reference 2 Relationship</label>
                <input formControlName="ref2Relationship" class="form-control" />
              </div>
              <div class="col-12">
                <label>Reference 2 Phone</label>
                <input formControlName="ref2Phone" class="form-control" />
              </div>

              <div class="col-12 col-md-6">
                <label>Reference 3 Name</label>
                <input formControlName="ref3name" class="form-control" />
              </div>
              <div class="col-12 col-md-6">
                <label>Reference 3 Relationship</label>
                <input formControlName="ref3Relationship" class="form-control" />
              </div>
              <div class="col-12">
                <label>Reference 3 Phone</label>
                <input formControlName="ref3Phone" class="form-control" />
              </div>

            </div>

            <div class="mt-4 d-flex justify-content-between">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext>Next</button>
            </div>

          </form>
        </mat-step>


        <!-- STEP: Background -->
        <mat-step [stepControl]="stepBackground">
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>gavel</mat-icon>Applicant Background</div></ng-template>

          <form [formGroup]="stepBackground">

            <div class="row g-3">

              <!-- Evicted -->
              <div class="col-12">
                <label data-required="*">Ever been evicted?</label>
                <select formControlName="evicted" class="form-select">
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                <div *ngIf="stepBackground.get('evicted')?.value === 'Yes'" class="mt-2">
                  <input formControlName="evictionDetails" class="form-control" placeholder="Explain..." />
                </div>
              </div>

              <!-- Bankruptcy -->
              <div class="col-12">
                <label data-required="*">Filed for bankruptcy?</label>
                <select formControlName="bankruptcy" class="form-select">
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                <div *ngIf="stepBackground.get('bankruptcy')?.value === 'Yes'" class="mt-2">
                  <input formControlName="bankruptcyDetails" class="form-control" placeholder="Explain..." />
                </div>
              </div>

              <!-- Landlord Balance -->
              <div class="col-12">
                <label data-required="*">Outstanding balances with landlords?</label>
                <select formControlName="landlordBalance" class="form-select">
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                <div *ngIf="stepBackground.get('landlordBalance')?.value === 'Yes'" class="mt-2">
                  <input formControlName="landlordBalanceDetails" class="form-control" placeholder="Explain..." />
                </div>
              </div>

              <!-- Lease violation -->
              <div class="col-12">
                <label data-required="*">Lease violation?</label>
                <select formControlName="leaseViolation" class="form-select">
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                <div *ngIf="stepBackground.get('leaseViolation')?.value === 'Yes'" class="mt-2">
                  <input formControlName="leaseViolationDetails" class="form-control" placeholder="Explain..." />
                </div>
              </div>

              <!-- Convicted -->
              <div class="col-12">
                <label data-required="*">Convicted of a crime?</label>
                <select formControlName="convicted" class="form-select">
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                <div *ngIf="stepBackground.get('convicted')?.value === 'Yes'" class="mt-2">
                  <input formControlName="crimeDetails" class="form-control" placeholder="Explain..." />
                </div>
              </div>

            </div>

            <div class="mt-4 d-flex justify-content-between">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext [disabled]="stepBackground.invalid">Next</button>
            </div>

          </form>
        </mat-step>


        <!-- STEP: Signature -->
        <mat-step [stepControl]="stepSignature">
          <ng-template matStepLabel><div class="steps-header" ><mat-icon>edit</mat-icon>Applicant Signature</div></ng-template>

          <form [formGroup]="stepSignature">

            <p class="mt-3">By signing below, you confirm the information is true.</p>

            <div class="row g-3">

              <div class="col-12 col-md-6">
                <label data-required="*">Signature (Full Name)</label>
                <input formControlName="signatureName" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepSignature,'signatureName')">Required</small>
              </div>

              <div class="col-12 col-md-6">
                <label data-required="*">Date</label>
                <input type="date" formControlName="signatureDate" class="form-control" />
                <small class="text-danger" *ngIf="isInvalid(stepSignature,'signatureDate')">Required</small>
              </div>

            </div>

            <div class="mt-4 d-flex justify-content-between">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-raised-button color="primary"
                      (click)="submitAll()"
                      [disabled]="loading || stepSignature.invalid">
                {{ loading ? 'Submitting...' : 'Submit Application' }}
              </button>
            </div>

          </form>
        </mat-step>
        <!-- SUCCESS STEP -->
        <mat-step *ngIf="submissionSuccess" [completed]="true">
          <ng-template matStepLabel>
            <div class="steps-header" >
              <mat-icon color="primary">check_circle</mat-icon>Success
            </div>
          </ng-template>

          <div class="success-wrapper fade-in">

            <!-- CONFETTI CANVAS -->
            <canvas id="confettiCanvas" class="confetti-canvas"></canvas>

            <div class="success-content text-center">
              <mat-icon class="success-icon">check_circle</mat-icon>

              <h2>Your Application Was Submitted!</h2>
              <p class="description">
                We’ve received your rental application successfully.
                Our team will contact you after reviewing your information.
              </p>

              <!-- <button mat-raised-button color="primary" (click)="goToDashboard()">
                Return to Home
                <mat-icon>arrow_forward</mat-icon>
              </button> -->
            </div>
          </div>
        </mat-step>


      </mat-stepper>

    </div>
  </div>
</div>
